// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"eventDetails_infoRow___VUr0","withIcon":"eventDetails_withIcon__q1YJ8","text":"eventDetails_text__wMQEm"};